import { Image } from '@heroui/react';
import { Trash2 } from 'lucide-react';
import React, { FC } from 'react';
import ReactCountryFlag from 'react-country-flag';

import www from '../../assets/images/www.svg?url';
import typePdf from '../../assets/pdf_file.svg?url';
import { Flex } from '../Flex';
import { FileCardWrapper, FilenameBox, FilenameEllipsis, Flag, FlagWrapper, ImageThumbnail, PreviewPopover } from './FileCard.styled';

type FileTypeProps = 'IMAGE' | 'PDF' | 'URL';
type FlagReturn = { type: 'iso' | 'local'; value: string };

interface FileCardProps {
    onRemove?: (fileName?: string) => void;
    onPreview?: () => string | undefined;
    fileName: string;
    fileType: FileTypeProps;
    currentFlag?: FlagReturn;
}

export const FileCard: FC<FileCardProps> = ({
  onRemove,
  onPreview,
  fileType,
  fileName,
  currentFlag,
}) => {
  const [hover, setHover] = React.useState(false);

  const getLastPathSegment = (url: string): string => {
    if (!url) return '';
    // usuń query/hash zanim zrobisz pop()
    const clean = url.replace(/[#?].*$/, '').replace(/\/+$/, '');
    const last = clean.split('/').pop() || '';
    try {
      return decodeURIComponent(last);
    } catch {
      return last;
    }
  };

  return (
    <FileCardWrapper onClick={onPreview}>
      <Flex direction="row" itemAlign="center" gap="10px">
        <FlagWrapper>
          {currentFlag
                        && (currentFlag.type === 'iso' ? (
                          <ReactCountryFlag
                            svg
                            style={{ width: '20px', height: '20px' }}
                            countryCode={currentFlag.value === 'en' ? 'gb' : currentFlag.value}
                          />
                        ) : (
                          <Flag src={currentFlag.value} alt="flag" />
                        ))}
        </FlagWrapper>

        {fileType === 'PDF' && (
        <Image src={typePdf} alt="icon-pdf" style={{ width: 24, height: 24 }} radius="none" />
        )}
        {fileType === 'IMAGE' && (
        <ImageThumbnail $imageUrl={fileName} />
        )}
        {fileType === 'URL' && (
        <Image src={www} alt="icon-url" style={{ width: 24, height: 24 }} radius="none" />
        )}

        <FilenameBox
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <FilenameEllipsis className="text-sm">
            {getLastPathSegment(fileName) || 'No data file name...'}
          </FilenameEllipsis>

          {fileType === 'IMAGE' && hover && (
            <PreviewPopover>
              <img
                src={fileName}
                alt="Podgląd"
                style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: 6 }}
              />
            </PreviewPopover>
          )}
        </FilenameBox>
      </Flex>

      <div>
        <Flex direction="row">
          <button
            type="button"
            className="text-red-500"
            onClick={(e) => {
              e.stopPropagation(); // żeby klik nie uruchamiał onPreview
              onRemove?.(fileName);
            }}
          >
            <Trash2 size="16" />
          </button>
        </Flex>
      </div>
    </FileCardWrapper>
  );
};
